import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import _ from "lodash";
import moment from "moment";
import DetailsTable from "components/schedule/DraftsDetails/details-table";
import Buttons from "components/schedule/DraftsDetails/buttons";
import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";
import WorkerProfile from "components/menu/master-files/workers-maintenance/worker-profile";
import DraftFilters from "components/schedule/DraftsDetails/draft-filters";

import {
    setEmployees
} from "actions/employeeActions";

import {
    batchBulkEdit,
    fetchDrafts,
    clearDrafts,
    fetchDraftsDetailsForExport,
    fetchDraftsDetailsPaged,
    setDraftStatus,
    draftSchedulerWorkerDelete,
    draftSchedulerWorkerInsert,
    draftSchedulerWorkerUpdate,
    bulkReplaceWorkerMethod
} from "actions/draftActions";

// import WorkersModal from "components/schedule/DraftsDetails/WorkersModal/modal";
const WorkersModal = React.lazy(() =>
    import("components/schedule/DraftsDetails/WorkersModal/modal"));

class DraftsDetails extends React.Component {
    inputsReadOnlyStatusArr = [
        "Complete",
        "Exported"
    ];

    modalObj = {};

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            draftsDetails: [],
            selectedDraftDetailId: "",
            activeFilters: {},
            workerRowId: "",
            actionType: "",

            requestParams: {}
        };

        this.handleClickCurrentWorker = this.handleClickCurrentWorker.bind(this);
        this.handleEditWorker = this.handleEditWorker.bind(this);
        this.handleInsertWorker = this.handleInsertWorker.bind(this);
        this.handleDeleteWorker = this.handleDeleteWorker.bind(this);
        this.handleModal = this.handleModal.bind(this);
        this.getExportData = this.getExportData.bind(this);
        this.handleExportData = this.handleExportData.bind(this);
        this.handleSetDraftStatus = this.handleSetDraftStatus.bind(this);
        this.handleBulkEdit = this.handleBulkEdit.bind(this);
        this.handleFilterCallback = this.handleFilterCallback.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.searchByFilters = this.searchByFilters.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
    }

    componentDidMount() {
        if (this.props.drafts.length === 0) {
            this.props.fetchDrafts();
        } else {
            this.setState({
                draftsDetails: this.props.draftsDetails
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.draftsDetails, this.props.draftsDetails)) {
            this.setState({
                draftsDetails: this.props.draftsDetails
            });
        }
    }

    componentWillUnmount() {
        this.modalObj = {};
        this.props.clearDrafts();
    }

    handleModal(actionType, selectedDraftDetailId, workerRowId, otherProps = {}) {
        const draftDetail = this.state.draftsDetails[selectedDraftDetailId];
        this.setState({
            actionType,
            selectedDraftDetailId,
            workerRowId
        });

        this.modalObj = {
            id: "select-independent-workers",
            modalSettings: {
                size: "lg"
            },
            header: "Select Independent Workers",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <WorkersModal
                        selectedDraftDetailId={selectedDraftDetailId}
                        handleInsertWorker={this.handleInsertWorker}
                        handleEditWorker={this.handleEditWorker}
                        handleEditWorkerAll={this.handleEditWorkerAll}
                        draftDetail={draftDetail}
                        workerRowId={workerRowId}
                        actionType={actionType}
                        otherProps={otherProps}
                        handleHide={() => this.props.closeCustomModal(this.modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(this.modalObj)
        };
        this.props.openCustomModal(this.modalObj);
    }

    handleClickCurrentWorker = (draftScheduleDetailsId, workerRowId, workerId, isTemporary) => {
        this.handleEditWorker(draftScheduleDetailsId, workerRowId, workerId, isTemporary);
    };

    handleInsertWorker = (draftDetailRowId, workerId) => {
        const draftsDetails = Object.assign([], this.state.draftsDetails);
        let isTeamLead = false;
        // console.error("draftsDetails", draftsDetails);
        // return;
        let currentDraftDetail = false;
        // eslint-disable-next-line no-restricted-syntax
        for (const draftsDetailIndex in draftsDetails) {
            if (draftsDetails[draftsDetailIndex].id === draftDetailRowId) {
                currentDraftDetail = draftsDetails[draftsDetailIndex];
                break;
            }
        }

        if (currentDraftDetail !== false) {
            isTeamLead = !currentDraftDetail.workers.filter((value) => value.isTeamLead).length;
        }

        this.props.draftSchedulerWorkerInsert(draftDetailRowId, workerId, isTeamLead);
        this.props.closeCustomModal(this.modalObj);
        this.props.setEmployees([]);
    };

    handleEditWorker = (draftDetailRowId, workerRowId, workerId, isTemporary = false) => {
        this.props.draftSchedulerWorkerUpdate(draftDetailRowId, workerRowId, workerId, isTemporary);
        this.props.closeCustomModal(this.modalObj);
        this.props.setEmployees([]);
    };

    handleEditWorkerAll = (oldWorkerId, newWorkerId) => {
        this.props.bulkReplaceWorkerMethod(oldWorkerId, newWorkerId, this.state.requestParams);
        this.props.closeCustomModal(this.modalObj);
        this.props.setEmployees([]);
    };

    handleBulkEdit = (propName, newValue) => {
        const {
            totalFilteredRecords
        } = this.props.draftsDetailsOptions;
        const confirmContent = (
            <div className="text-center">
                This operation will affect <b>{totalFilteredRecords}</b> records.
                <br/>Continue?
            </div>
        );

        const onAccept = () => {
            this.props.batchBulkEdit(propName, newValue, this.state.requestParams);
        };

        const modalObj = {
            id: "",
            header: "Confirm",
            children: confirmContent,
            buttons: {
                accept: {
                    text: "Accept",
                    callback: () => {
                        onAccept();
                        this.props.closeCustomModal(modalObj);
                    }
                },
                cancel: {
                    text: "Cancel",
                    callback: () => this.props.closeCustomModal(modalObj)
                },
            },
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleWorkerProfileModal = (workerId) => {
        const modalObj = {
            id: `WorkerProfile-${workerId}`,
            modalSettings: {
                size: "lg"
            },
            header: `Employee View (id: ${workerId})`,
            children: <WorkerProfile workerId={workerId}/>,
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleExportData(callback) {
        const requestParams = Object.assign({}, this.state.requestParams);
        requestParams.pageNumber = 0;
        requestParams.pageSize = this.props.draftsDetailsOptions.totalFilteredRecords;
        this.props.fetchDraftsDetailsForExport(requestParams, (response) => {
            callback(this.getExportData(response.payload));
        });
    }

    getExportData(draftsDetails = false) {
        if (draftsDetails === false) {
            draftsDetails = this.state.draftsDetails;
        }
        const csvArray = [];
        let previousMerchandiserLengthMax = 1,
            currentMerchandiserLengthMax = 1;
        draftsDetails.forEach((draft) => {
            if (draft.previousWorkers.length > previousMerchandiserLengthMax) {
                previousMerchandiserLengthMax = draft.previousWorkers.length;
            }
            if (draft.workers.length > currentMerchandiserLengthMax) {
                currentMerchandiserLengthMax = draft.workers.length;
            }
        });
        const csvHeader = [
            "Retailer",
            "Store #",
            "Province",
            "City",
            "Address",
            "Job",
            "Helper Job",
            "Product",
            "Service Type",
            "Trait",
            "Hours",
            "Start Date",
            "End Date",
            // "Previous Merchandiser(s)",
            // "Current Merchandiser(s)"
        ];
        for (let i = 0; i < previousMerchandiserLengthMax; i += 1) {
            if (i === 0) {
                csvHeader.push("Previous Merchandiser(Team Lead)");
            } else {
                csvHeader.push("Previous Merchandiser(Helper)");
            }
        }
        for (let i = 0; i < currentMerchandiserLengthMax; i += 1) {
            if (i === 0) {
                csvHeader.push("Current Merchandiser(Team Lead)");
            } else {
                csvHeader.push("Current Merchandiser(Helper)");
            }
        }

        csvArray.push(csvHeader);

        draftsDetails.forEach((rowArray) => {
            const row = [
                rowArray.retailer,
                rowArray.store.storeNumber,
                rowArray.store.province,
                rowArray.store.city,
                rowArray.store.address1.concat(" ").concat(rowArray.store.address2),
                _.has(rowArray.mainJobProduct, "jobNumber") ? rowArray.mainJobProduct.jobNumber : "",
                _.has(rowArray.helperJobProduct, "jobNumber") ? rowArray.helperJobProduct.jobNumber : "",
                _.has(rowArray.mainJobProduct, "product") ? rowArray.mainJobProduct.product : "",
                rowArray.serviceType,
                rowArray.trait,
                rowArray.hours,
                rowArray.startDate ? moment(rowArray.startDate).format("YYYY-MM-DD") : "",
                rowArray.endDate ? moment(rowArray.endDate).format("YYYY-MM-DD") : ""
            ];

            for (let i = 0; i < previousMerchandiserLengthMax; i += 1) {
                if (rowArray.previousWorkers[i]) {
                    row.push(rowArray.previousWorkers[i].name);
                } else {
                    row.push("");
                }
            }

            for (let i = 0; i < currentMerchandiserLengthMax; i += 1) {
                if (rowArray.workers[i]) {
                    row.push(rowArray.workers[i].name);
                } else {
                    row.push("");
                }
            }

            csvArray.push(row);
        });

        return csvArray;
    }

    handleSetDraftStatus(draftId, status) {
        this.props.setDraftStatus(draftId, status);
    }

    handleDeleteWorker(draftDetailRowId, workerRowId) {
        this.props.draftSchedulerWorkerDelete(draftDetailRowId, workerRowId);
    }

    getDraftsName = () => {
        const draftIds = this.props.match.params.ids.split(",");
        if (draftIds.length > 1) {
            return "";
        }
        const drafts = this.props.drafts;
        const name = [];
        draftIds.forEach(id => {
            const draft = drafts.find(item => item.id === parseInt(id, 10));
            if (draft) {
                name.push(draft.name);
            }
        });
        return name.join(",");
    };

    handleFilterCallback(filterKey, value, isArray, callback = false) {
        const activeFilters = Object.assign({}, this.state.activeFilters);

        activeFilters[filterKey] = value;

        this.setState({
            activeFilters
        }, () => {
            if (typeof callback === "function") {
                callback();
            }
        });
    }

    resetFilters(callback = false) {
        this.setState({
            activeFilters: {}
        }, () => {
            if (typeof callback === "function") {
                callback();
            } else {
                this.searchByFilters(true);
            }
        });
    }

    searchByFilters(resetPage = true) {
        if (resetPage) {
            const { tableState } = this.state;
            tableState.page = 0;
            this.setState({
                tableState
            }, () => {
                this.handleTableChange(tableState, true);
            });
        } else {
            this.handleTableChange(this.state.tableState, true);
        }
    }

    handleTableChange(tableState, isManual = false) {
        const {
            activeFilters
        } = this.state;
        const ids = this.props.match.params.ids.split(",");
        const requestParams = {
            draftIds: ids,
            pageNumber: tableState.page,
            pageSize: tableState.pageSize,
            sortOptions: null
        };

        // sorts
        if (tableState.sorted.length) {
            requestParams.sortOptions = {};
            tableState.sorted.forEach(item => {
                requestParams.sortOptions[item.id] = item.desc;
            });
        }

        // filters
        const notNeedFloatArr = ["traits", "exceptions"];
        Object.keys(activeFilters).forEach((key) => {
            const parseFloatValue = notNeedFloatArr.indexOf(key) === -1;
            requestParams[key] = null;
            if (activeFilters[key] !== null && typeof activeFilters[key] === "string") {
                requestParams[key] = activeFilters[key];
            } else if (activeFilters[key] !== null && activeFilters[key].value) {
                requestParams[key] = activeFilters[key].value;
                if (parseFloatValue) {
                    requestParams[key] = parseFloat(requestParams[key]);
                }
            } else if (Array.isArray(activeFilters[key]) && activeFilters[key].length) {
                requestParams[key] = activeFilters[key].map(item => {
                    if (parseFloatValue) {
                        return parseFloat(item.value);
                    }
                    return item.value;
                });
            }
        });

        let page = tableState.page;
        if (isManual) {
            page = 0;
        }

        this.setState({
            requestParams,
            page,
            tableState: {
                page: tableState.page,
                pageSize: tableState.pageSize,
                sorted: tableState.sorted,
            },
        });

        this.props.fetchDraftsDetailsPaged(requestParams);
    }

    getRetailerIdFromDraftDetails = (draftsDetails) => {
        const retailersIdArr = {};
        draftsDetails.forEach(draftsDetail => {
            retailersIdArr[draftsDetail.retailerId] = true;
        });

        const retailersIdArrKeys = Object.keys(retailersIdArr);
        if (retailersIdArrKeys.length !== 1) {
            return false;
        }

        return parseInt(retailersIdArrKeys[0], 10);
    };

    render() {
        const {
            draftsDetailsOptions,
            loading
        } = this.props;

        const {
            page,
            draftsDetails,
            activeFilters,
            requestParams
        } = this.state;

        const draftIds = this.props.match.params.ids
            .split(",")
            .map((id) => parseInt(id, 10));

        let currentDraft = false;
        const inputsReadOnly = {};
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const index in this.props.drafts) {
            if (draftIds.indexOf(this.props.drafts[index].id) !== -1) {
                currentDraft = this.props.drafts[index];
                inputsReadOnly[currentDraft.id] =
                    this.inputsReadOnlyStatusArr.indexOf(currentDraft.status) !== -1;
            }

            if (draftIds.length <= Object.keys(inputsReadOnly).length) {
                break;
            }
        }

        const {
            totalFilteredRecords,
            totalRecords
        } = draftsDetailsOptions;

        let draftNames = this.getDraftsName();
        if (loading) {
            draftNames = "Loading...";
        } else if (draftNames === "") {
            draftNames = `Multiple Draft Schedules (${draftIds.length})`;
        } else {
            draftNames = `Draft Schedules (${draftNames})`;
        }

        return (
            <div>

                <DraftFilters
                    title={draftNames}
                    titleFilteredCounts={{
                        totalFilteredRecords: totalFilteredRecords || 0,
                        totalRecords: totalRecords || 0
                    }}
                    filters={draftsDetailsOptions.metadata}
                    activeFilters={activeFilters}
                    filterCallback={this.handleFilterCallback}
                    onSearch={this.searchByFilters}
                    onReset={this.resetFilters}
                />

                <DetailsTable
                    draftsDetails={draftsDetails}
                    inputsReadOnly={inputsReadOnly}
                    handleClickCurrentWorker={this.handleClickCurrentWorker}
                    handleDeleteWorker={this.handleDeleteWorker}
                    handleModal={this.handleModal}
                    handleBulkEdit={this.handleBulkEdit}
                    handleWorkerProfileModal={this.handleWorkerProfileModal}
                    handleTableChange={this.handleTableChange}
                    pages={Math.ceil(
                        draftsDetailsOptions.totalFilteredRecords /
                        draftsDetailsOptions.pageSize
                    )}
                    page={page}
                    handleRefreshPage={() => this.searchByFilters(false)}
                />

                <Buttons
                    draftIds={draftIds}
                    draftsDetails={draftsDetails}
                    drafts={this.props.drafts}
                    metadata={requestParams}
                    retailerId={this.getRetailerIdFromDraftDetails(draftsDetails)}
                    selectedDraftsIds={this.props.match.params.ids.split(",")}
                    handleSetDraftStatus={this.handleSetDraftStatus}
                    handleExportData={this.handleExportData}
                />
            </div>
        );
    }
}

DraftsDetails.propTypes = {
    drafts: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    draftsDetails: PropTypes.array.isRequired,
    draftsDetailsOptions: PropTypes.object.isRequired,
    fetchDraftsDetailsPaged: PropTypes.func.isRequired,
    fetchDraftsDetailsForExport: PropTypes.func.isRequired,
    fetchDrafts: PropTypes.func.isRequired,
    setDraftStatus: PropTypes.func.isRequired,
    batchBulkEdit: PropTypes.func.isRequired,
    draftSchedulerWorkerDelete: PropTypes.func.isRequired,
    draftSchedulerWorkerInsert: PropTypes.func.isRequired,
    draftSchedulerWorkerUpdate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    drafts: state.draft.drafts,
    loading: state.draft.loading,
    draftsDetails: state.draft.draftsDetails,
    draftsDetailsOptions: state.draft.draftsDetailsOptions,
});

const mapStateToDispatch = dispatch => ({
    fetchDraftsDetailsPaged: bindActionCreators(fetchDraftsDetailsPaged, dispatch),
    fetchDraftsDetailsForExport: bindActionCreators(fetchDraftsDetailsForExport, dispatch),
    fetchDrafts: bindActionCreators(fetchDrafts, dispatch),
    clearDrafts: bindActionCreators(clearDrafts, dispatch),
    setEmployees: bindActionCreators(setEmployees, dispatch),
    setDraftStatus: bindActionCreators(setDraftStatus, dispatch),
    batchBulkEdit: bindActionCreators(batchBulkEdit, dispatch),
    draftSchedulerWorkerDelete: bindActionCreators(draftSchedulerWorkerDelete, dispatch),
    draftSchedulerWorkerInsert: bindActionCreators(draftSchedulerWorkerInsert, dispatch),
    draftSchedulerWorkerUpdate: bindActionCreators(draftSchedulerWorkerUpdate, dispatch),
    bulkReplaceWorkerMethod: bindActionCreators(bulkReplaceWorkerMethod, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch,
)(DraftsDetails);
